import { useMemo } from 'react';

import { useWindowSize } from './windowSize';
import { useServer } from '@/modules/server/context/ServerEnvContext';

import { doublePadding, ScreenSize } from '@/styles/helpers';

export const useDevice = () => {
  const { isMobileDevice: isMobileServer } = useServer();
  const { width } = useWindowSize();

  const isMobileDevice = useMemo(() => {
    if (!width) return isMobileServer;

    return ScreenSize.DESKTOP + doublePadding >= width;
  }, [width]);

  return { isMobileDevice };
};
